<div class="marine-insurance-beneficiary-view-data">
  <div class="row mb-1" *ngIf="!isShowOnlyAddress">
    <div class="col-4 marine-insurance-beneficiary-view-data-label">
      {{ "LABELS.NAME" | translate }}
    </div>
    <div class="col-8 marine-insurance-beneficiary-view-data-value">
      {{ beneficiary?.name }}
    </div>
  </div>

  <div class="row mb-1">
    <div class="col-4 marine-insurance-beneficiary-view-data-label">
      {{ "LABELS.ADDRESS" | translate }}
    </div>
    <div class="col-8 marine-insurance-beneficiary-view-data-value">
      <address-details [address]="beneficiary?.address"></address-details>
    </div>
  </div>

  <div class="row mb-1" *ngIf="!!beneficiary?.phone && isShowPhone && !isShowOnlyAddress">
    <div class="col-4 marine-insurance-beneficiary-view-data-label">
      {{ "LABELS.PHONE" | translate }}
    </div>
    <div class="col-8 marine-insurance-beneficiary-view-data-value">
      <a href="tel:{{ beneficiary?.phone }}">{{ beneficiary?.phone }}</a>
    </div>
  </div>

  <div class="row mb-1" *ngIf="!!beneficiary?.email && isShowEmail && !isShowOnlyAddress">
    <div class="col-4 marine-insurance-beneficiary-view-data-label">
      {{ "FORM_LABEL.EMAIL_SHORT" | translate }}
    </div>
    <div class="col-8 marine-insurance-beneficiary-view-data-value">
      <a href="mailto:{{ beneficiary?.email }}">{{ beneficiary?.email }}</a>
    </div>
  </div>
</div>
